<template>
  <section class="page-error">
    <h1>404</h1>
    <p>找不到的页面</p>
  </section>
</template>


<script>
  export default {
    name: '404 page'
  }
</script>

<style scoped>
  .page-error{
    text-align: center;
    padding: 200px 0 0
  }
  .page-error h1{display:inline-block;padding:20px;margin-bottom:20px;font-size:60px;border-radius: 100%;background-color: #fff;}
  .page-error p{font-size:14px;color: #999}
</style>
